import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as Cal from '../calendarHelper.js';
import CreateMonth from './CreateMonth.jsx';
import {setEventDate, setMonthShown, setShowFutureEvents} from '../redux/actions';
import DateChanger from './DateChanger'
import logger from "redux-logger";

class CalendarDisplay extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstDayOfMonth: null,
      daysInMonth: null,
      prevMonthDays: null,
      monthsSelector: false
    }
  }

  resizeObserver = null;

  resizeEventList = () => {
    // console.log('should resize');
    setTimeout(() => {
      let calObj = document.querySelector('.Calendar');
      let eveObj = document.querySelector('.eventDisplay');

      eveObj.style.height = `${calObj.offsetHeight}px`;
    }, 100);
  };

  prevMonth = () => {
    let tempMonth = {...this.props.monthShown};
    if (tempMonth.month == 0) {
      tempMonth.year--;
      tempMonth.month = 11;
    } else {
      tempMonth.month--;
    }
    Cal.changePageButtonHref(tempMonth);
    const theFirst = Cal.correctDateFormat(tempMonth.year,tempMonth.month);
    if (Cal.sameMonthStrings(theFirst, this.props.today)) {
      this.props.setEventDate(this.props.today);
    } else {
      this.props.setEventDate(theFirst);
    }
    this.props.setShowFutureEvents();
    this.props.setMonthShown(tempMonth);
    this.setState({
      firstDayOfMonth: Cal.firstDayOfMonth(this.props.year, this.props.month),
      daysInMonth: Cal.getDaysInMonth(this.props.year, this.props.month),
      prevMonthDays: Cal.getPrevMonthDays(this.props.year, this.props.month),
    }, () => ""); // console.log('this.state', this.state)
  }

  nextMonth = () => {
    let tempMonth = {...this.props.monthShown};
    if (tempMonth.month >= 11) {
      tempMonth.year++;
      tempMonth.month = 0;
    } else {
      tempMonth.month++;
    }
    Cal.changePageButtonHref(tempMonth);
    const theFirst = Cal.correctDateFormat(tempMonth.year,tempMonth.month);
    if (Cal.sameMonthStrings(theFirst, this.props.today)) {
      this.props.setEventDate(this.props.today);
    } else {
      this.props.setEventDate(theFirst);
    }
    this.props.setShowFutureEvents()
    this.props.setMonthShown(tempMonth);
    this.setState({
      firstDayOfMonth: Cal.firstDayOfMonth(this.props.year, this.props.month),
      daysInMonth: Cal.getDaysInMonth(this.props.year, this.props.month),
      prevMonthDays: Cal.getPrevMonthDays(this.props.year, this.props.month),
    }, () => ""); // console.log('this.state', this.state)
  }

  showMonthSelector = () => {
    this.setState({monthsSelector: !this.state.monthsSelector})
  }

  componentDidMount() {
    const calObj = document.querySelector('.Calendar');
    this.resizeObserver = new ResizeObserver(entries => {
      for (let entry of entries) {
        this.resizeEventList();
      }
    });

    if (this.resizeObserver !== null && this.resizeObserver !== {} && calObj !== null) {
      this.resizeObserver.observe(calObj);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.month !== null && this.props.year !== null && (prevProps.month + prevProps.year !== this.props.month + this.props.year)) {
      this.setState({
        firstDayOfMonth: Cal.firstDayOfMonth(this.props.year, this.props.month),
        daysInMonth: Cal.getDaysInMonth(this.props.year, this.props.month),
        prevMonthDays: Cal.getPrevMonthDays(this.props.year, this.props.month),
      });
    }
  }

  componentWillUnmount() {
    if (!!this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  }

  render() {
    if (this.state.month === null || this.state.year === null) {
      return (
        <div>
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Loading&hellip;
        </div>
      )
    }
    return (
      <>
        {this.state.monthsSelector ? <div onClick={this.showMonthSelector} className="timeChangeWrapper"></div> : null}
        <h2 className="monthYear"><span onClick={this.prevMonth} className="prev">prev</span>
          <button className="MonthAndYearDisplay btn dropdown-toggle p-0" onClick={this.showMonthSelector}>
            {Cal.getMonthName(this.props.month, this.props.year)} {this.props.year}
          </button>
          <span onClick={this.nextMonth} className="next">next</span>
        </h2>

        {this.state.monthsSelector ?
          <div className="position-relative">
            <div className="timeChangeModal">
              <DateChanger monthsSelector={this.showMonthSelector} today={this.props.today} />
            </div>
          </div>
          : null}

        <CreateMonth
          {...this.state}
        />
      </>
    )
  }
}

const mapStateToProps = state => ({
  error: state.calendarEvents.error,
  fetching: state.calendarEvents.fetching,
  monthShown: state.calendarEvents.monthShown,
  month: state.calendarEvents.month,
  year: state.calendarEvents.year,
});

const mapDispatchToProps = {
  setMonthShown,
  setEventDate,
  setShowFutureEvents,
};

export default connect(mapStateToProps, mapDispatchToProps)(CalendarDisplay);